import React, { useState } from "react";
import { Table, Card, Button, Offcanvas } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

const TreatmentsEpisodes = ({ onClose, patient, episodes: initialEpisodes }) => {
    const [isMainPanelOpen, setIsMainPanelOpen] = useState(true);
    const [episodes, setEpisodes] = useState(initialEpisodes || []);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }

        const sortedEpisodes = [...episodes].sort((a, b) => {
            if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
            if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setEpisodes(sortedEpisodes);
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return <FaSort />;
        return sortConfig.direction === "asc" ? <FaSortUp /> : <FaSortDown />;
    };

    const closeMainPanel = () => {
        setIsMainPanelOpen(false);
        onClose();
    };

    const columnLabels = {
        type: "Type",
        episode: "Episode",
        reason: "Reason",
        admissionDate: "Admission Date",
        dischargeDate: "Discharge Date",
        closingDate: "Closing Date",
        doctor: "Doctor",
        specialty: "Specialty",
        outpatientType: "Outpatient Type",
        history: "History"
    };

    return (
        <Offcanvas 
            show={isMainPanelOpen} 
            onHide={closeMainPanel} 
            placement="end"
            style={{ width: '1260px', maxWidth: '90vw' }}
            scroll={true}
            backdrop={true}
        >
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title className="fw-semibold">Episodes</Offcanvas.Title>
            </Offcanvas.Header>
            
            <Offcanvas.Body className="p-3">
                {patient && (
                    <Card className="mb-3 shadow-sm">
                        <Card.Body>
                            <div className="d-flex align-items-center flex-wrap">
                                {patient.photo && (
                                    <img 
                                        src={patient.photo} 
                                        alt="Profile" 
                                        className="rounded-circle me-3" 
                                        width="60" 
                                        height="60"
                                    />
                                )}
                                <div className="flex-grow-1">
                                    <h5 className="mb-1 fw-bold">{patient.name}</h5>
                                    <p className="text-muted mb-0 small">
                                        {patient.email && (
                                            <>
                                                <FaEnvelope className="text-primary me-1"/> {patient.email}
                                            </>
                                        )}
                                        {patient.email && patient.phone && <span className="mx-2">|</span>}
                                        {patient.phone && (
                                            <>
                                                <FaPhone className="text-success me-1"/> {patient.phone}
                                            </>
                                        )}
                                    </p>
                                </div>
                                {patient.insurance && (
                                    <div className="ms-auto text-end">
                                        <p className="mb-1">
                                            <strong>{patient.insurance}</strong>
                                        </p>
                                        {patient.insuranceId && (
                                            <span className="text-muted small">ID {patient.insuranceId}</span>
                                        )}
                                        <div className="mt-2">
                                            <Button variant="primary" size="sm">Patient Treatments</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                )}

                <div className="table-responsive">
                    <Table striped bordered hover className="text-center mb-0">
                        <thead className="table-light">
                            <tr>
                                {Object.keys(columnLabels).map((key) => (
                                    <th 
                                        key={key} 
                                        onClick={() => handleSort(key)} 
                                        style={{ cursor: 'pointer', userSelect: 'none' }}
                                        className="align-middle"
                                    >
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <span>{columnLabels[key]}</span>
                                            <span className="ms-1">{getSortIcon(key)}</span>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {episodes.length > 0 ? (
                                episodes.map((ep, index) => (
                                    <tr key={index}>
                                        <td className="align-middle">{ep.type}</td>
                                        <td className="align-middle">{ep.episode}</td>
                                        <td className="align-middle">{ep.reason}</td>
                                        <td className="align-middle">{ep.admissionDate}</td>
                                        <td className="align-middle">{ep.dischargeDate}</td>
                                        <td className="align-middle">{ep.closingDate}</td>
                                        <td className="align-middle">{ep.doctor}</td>
                                        <td className="align-middle">{ep.specialty}</td>
                                        <td className="align-middle">{ep.outpatientType}</td>
                                        <td className="align-middle">{ep.history}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" className="text-muted py-4">
                                        No episodes found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default TreatmentsEpisodes;